import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  handleResponse({ detail: [xhr] }) {
    this.element.outerHTML = xhr.responseText
  }
}
